import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useFunctionalAccess } from '../../hooks/useFunctionalAccess';
import { REPORTS_TABLE_URL } from '../../utils/Urls.constant';

interface SecureRouteProps {
    children: React.ReactNode;
}

const SecureRouteReports = ({ children }: SecureRouteProps) => {
    const { functionalAccess, isFetchingAccess } = useFunctionalAccess();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isFetchingAccess && !functionalAccess?.viewTaxReturnsEnabled) {
            navigate(REPORTS_TABLE_URL);
        }
    }, [functionalAccess?.viewTaxReturnsEnabled, isFetchingAccess]);

    if (!isFetchingAccess && !functionalAccess?.viewTaxReturnsEnabled) {
        return null;
    } else {
        return <>{children}</>;
    }
};

export default SecureRouteReports;
